/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { OrganisationStoreRequest, OrganisationStoreResponse } from '../types/OrganisationStore'

/**
 * POST /organisations
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::store
 */
export async function organisationStore(
	data: OrganisationStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationStoreResponse>> {
	return axiosInstance.post('/organisations', data, config)
}
